import { useState } from "react"

import { useToast } from "@supliful/common"

export const useImageResize = (): [
  (file: File) => Promise<File | null>,
  { loading: boolean },
] => {
  const [loading, setIsloading] = useState(false)
  const toast = useToast()

  const resize = async (file: File) => {
    setIsloading(true)

    // Post the image to the `images/resize` API route that returns a smaller sized image version.
    const data = new FormData()
    data.set("image", file)

    const response = await fetch("/api/images/resize", {
      method: "POST",
      body: data,
    })

    if (response.status !== 200) {
      setIsloading(false)
      toast({
        status: "error",
        description:
          "Error while resizing image. Please try uploading a smaller sized image.",
      })
      return null
    }

    // Re-create a File object from the Blob.
    const blob = await response.blob()
    const resizedImage = new File([blob], file.name, {
      type: file.type,
    })

    setIsloading(false)
    return resizedImage
  }

  return [resize, { loading }]
}
